import React from 'react';
import { Route, Routes } from "react-router-dom";
import ErrorPage from './pages/error-page';
import ECLoginPage from './enterprise-client/login/ec-login-page';

export default function EnterpriseClient() {
    return (
        <Routes>
            <Route path="/" element={<ECLoginPage />} />
            <Route path="error" element={<ErrorPage />} />
        </Routes>
    );
}
